export default __webpack_public_path__ + "static/envelope-abbccd91507911609201f163e02abe13.gif";